import { memo, useMemo, useRef, useState, useEffect } from 'react';
import { LandmarkPoetryPlaceInfo, PageMode } from '@/store/types';
// import { getAssetUrl } from '@/utils/common';
import PoetrySpot from './components/PoetrySpot';
import styles from './index.module.scss';
import { useQueryGetPlaceJson, useQueryPoetry } from '@/services/hooks';
import LandmarkPoetryDetail from './components/LandmarkPoetryDetail';
import LandmarkPoetryFigureDetail from './components/LandmarkPoetryFigureDetail';
import LandmarkAuthorDetail from './components/LandmarkAuthorDetail';
import { useStore } from "@/store";
import { useTransition, animated } from '@react-spring/web';
import QrCode from '@/components/QrCode';
import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';

const LandmarkPoetry = () => {
  const timeRef = useRef<any>(null);
  const { data: placeData } = useQueryGetPlaceJson();
  const { data } = useQueryPoetry();
  // console.log('data',data?.map((i:any)=>i.name+':'+i.ext_neighborList.length));
  const mode = useStore((state) => state);
  const [originalData, setOriginalData] = useState<any[]>([]);


  const placeId = useStore((state) => state.landmarkPoetryPlaceId);
  const placeType = useStore((state) => state.landmarkPoetryPlaceType);
  const placeAuthor = useStore((state) => state.landmarkPoetryPlaceAuthor);

  
  const getRandomItems = (data: any) => {    
    const rotation: any = {};
    data?.forEach((ele: any) => {
      const rotationTag = ele?.tags?.filter((item: any) => item.includes('诗词轮播'))?.[0];
      if (rotationTag) {
        if (!rotation[rotationTag]) {
          rotation[rotationTag] = [];
        }
        rotation[rotationTag].push(ele);
      }
     
    });
    const authorsArray = Object.entries(rotation).map(([number, content]) => ({
      number,
      content
    })).sort((a: any, b: any) => a.number.match(/\d+$/)?.[0] - b.number.match(/\d+$/)?.[0])
    return authorsArray;
  };
  const startRandomDataFetching = (list: any) => {
    let count = 0;
    const randomItems: any = getRandomItems(list);
    const interval = 5000; // 5 秒
    const fetchData = () => {
      setOriginalData(randomItems?.[count]?.content);
      count++;
      if (count > randomItems.length) {
        count = 0;
      }
    };
    fetchData(); // 立即执行一次
    timeRef.current = setInterval(fetchData, interval);
  };
  
  useEffect(() => {
    if (data && data.length > 0 && placeData) {
      const list = data.map((item: any) => {
        const res = placeData.filter((itm: any) => itm.name === item.name)[0];
        if (res) {
          return {
            ...res,
            ...item,
          }
        }
      }).filter((itm: any) => itm !== undefined)
      startRandomDataFetching(list);
    }
    if (mode.mode !== PageMode.LANDMARK_POETRY) {
      clearInterval(timeRef.current);
      timeRef.current = null;
    }
    return () => clearInterval(timeRef.current);
  },[data, placeData])


  // 语音控制
  useEffect(()=>{
    if(!placeId&&!placeType&&!placeAuthor){
      // console.log('placeId',placeId,placeType,placeAuthor);
      driveDigitalHumanByText('西湖及其周边群山，留下数不尽的名篇佳作，此处精选100+个文学地标，通过每个地标积淀的诗词文章数据，洞见不一样的文学西湖。');
    }
  },[])


  const transitions = useTransition(originalData, {
    keys: (item) => item.entity_id,
    from: { scale: 0, opacity: 0 },
    enter: { scale: 1, opacity: 1 },
    leave: { scale: 0, opacity: 0 },
    config: { tension: 180 * 1, friction: 12 },
    trail: 100,
  });


  return (
    <>
      <div className={styles.container}>
        {transitions((style, place, _, index) => (
          <animated.div
            key={place.entity_id}
            style={{
              position: 'absolute',
              ...style,
              x: place.x,
              y: place.y,
            }}
          >
            <PoetrySpot place={place} index={index} />
          </animated.div>
        ))}
      </div>
      <LandmarkPoetryDetail />
      <LandmarkPoetryFigureDetail />
      <LandmarkAuthorDetail />
      <QrCode />
    </>
  );
};

export default memo(LandmarkPoetry);

